import { showUserInfo } from './user-toast';

/**
 * 额度耗尽类通知的专用入口（BUG-010，BUG-011 收口到 user-toast）。
 *
 * 这类通知需要家长特别注意（“本周期额度已用完，xx月xx日自动恢复”），
 * 视觉上要求在手机端当前可视区域水平、垂直居中，而不是贴近页面顶部。
 * 通过 `showUserInfo` 统一打上 `user-toast` 标记（BUG-011 的共享封装），
 * 由 `index.css` 中的样式对该标记做居中处理；同时保留
 * `quota-exhausted-toast` 语义类，便于后续单独区分额度耗尽类通知。
 *
 * 管理员成功/失败、复制成功等普通 toast 不携带该标记，位置与行为完全不变。
 *
 * 与 toast.info 相同的默认行为：自动消失、点击关闭、role=status 无障碍语义。
 */
export function showQuotaExhaustedToast(message: string): string | number {
  return showUserInfo(message, {
    className: 'quota-exhausted-toast',
  });
}
